<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-coded-lock`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.153 9.774a1 1 0 01.104.104l15.406 17.86c.169.236.278.517.316.824.005.038.008.076.011.115.002.037.01.07.01.107 0 .02-.005.041-.006.062-.001.087-.01.173-.032.306a1.7 1.7 0 01-.774 1.145c-.053.031-.108.05-.161.075-.027.013-.053.027-.08.038a1.654 1.654 0 01-.161.053c-.066.02-.133.037-.224.05-.077.012-.154.025-.235.025h-8.365v12.37c0 .603-.5 1.092-1.116 1.092H18.154a1.103 1.103 0 01-1.116-1.091v-12.37H8.673c-.08 0-.158-.014-.256-.028a1.754 1.754 0 01-.203-.048 1.661 1.661 0 01-.16-.053c-.028-.01-.054-.025-.08-.038-.054-.024-.11-.044-.162-.075-.42-.256-.685-.68-.781-1.191a1.787 1.787 0 01-.025-.26c0-.02-.006-.041-.006-.062 0-.037.008-.07.01-.107a1.788 1.788 0 01.327-.94l15.406-17.86a1 1 0 011.41-.103zM39 4a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1V5a1 1 0 011-1h31z"/></svg>
</template>
<script>

export default {
  name: 'IconCodedLock',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
